const BASE_URL = process.env.REACT_APP_API_URL || 'https://api.podee.ai';

// Global error handler for 401 responses
let globalLogoutHandler = null;
let globalNavigateHandler = null;

// Initialize the global error handlers
export const initializeApiErrorHandlers = (logout, navigate) => {
  globalLogoutHandler = logout;
  globalNavigateHandler = navigate;
};

// Get the stored access token
const getAuthToken = () => {
  return localStorage.getItem('access_token');
};

// Get the token type
const getTokenType = () => {
  return localStorage.getItem('token_type') || 'Bearer';
};

// Make an authenticated API request
export const apiRequest = async (endpoint, options = {}) => {
  const token = getAuthToken();
  const tokenType = getTokenType();
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  
  // Add authorization header if token exists
  if (token) {
    defaultHeaders['Authorization'] = `${tokenType} ${token}`;
  }
  
  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };
  
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      ...config,
      mode: 'cors',
    });
    
    // If unauthorized, handle logout and redirect
    if (response.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('token_type');
      localStorage.removeItem('user');
      
      // Call global handlers if they exist
      if (globalLogoutHandler && globalNavigateHandler) {
        globalLogoutHandler();
        globalNavigateHandler('/signin');
      }
    }
    
    return response;
  } catch (error) {
    console.error('API request failed:', error);
    throw error;
  }
};

// Helper function for GET requests
export const apiGet = (endpoint) => {
  return apiRequest(endpoint, { method: 'GET' });
};

// Helper function for POST requests
export const apiPost = (endpoint, data) => {
  return apiRequest(endpoint, {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

// Helper function for PUT requests
export const apiPut = (endpoint, data) => {
  return apiRequest(endpoint, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
};

// Helper function for DELETE requests
export const apiDelete = (endpoint) => {
  return apiRequest(endpoint, { method: 'DELETE' });
};

export default {
  apiRequest,
  apiGet,
  apiPost,
  apiPut,
  apiDelete,
};
